import React, { useEffect, useState } from "react";

const links = [
  { href: "#about-me", label: "About" },
  { href: "#experiences", label: "Experience" },
  { href: "#projects", label: "Projects" },
  { href: "#lets-talk", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-[#151515]/90 backdrop-blur border-b border-gray-800"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-8 flex items-center justify-between h-16">
        <a href="#top" className="font-bold text-xl tracking-wide">
          Andy<span className="text-teal-500">.</span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm gray-font hover:text-white transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#lets-talk"
            className="text-sm font-semibold bg-teal-500 hover:bg-teal-400 text-black px-4 py-2 rounded-lg transition-colors"
          >
            Let's Talk
          </a>
        </div>

        <button
          type="button"
          className="md:hidden text-2xl w-10 h-10"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <i className={`fa ${open ? "fa-times" : "fa-bars"}`} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden px-8 pb-6 pt-2 flex flex-col gap-1 bg-[#151515]/95 backdrop-blur border-b border-gray-800">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="py-3 text-base gray-font hover:text-white transition-colors border-b border-gray-800/60 last:border-b-0"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
